const biologyQuestions = [

{
  question: "Which of the following best explains why mitochondria are abundant in muscle cells?",
  options: [
    "they store genetic material",
    "they produce energy for contraction",
    "they control cell division",
    "they synthesize proteins"
  ],
  answer: "they produce energy for contraction"
},
{
  question: "A cell placed in a hypertonic solution will:",
  options: [
    "gain water and burst",
    "lose water and shrink",
    "remain unchanged",
    "divide rapidly"
  ],
  answer: "lose water and shrink"
},
{
  question: "Which of the following processes requires energy directly from ATP?",
  options: [
    "diffusion",
    "osmosis",
    "active transport",
    "facilitated diffusion"
  ],
  answer: "active transport"
},
{
  question: "Which organelle is most directly involved in detoxification of drugs in liver cells?",
  options: [
    "rough endoplasmic reticulum",
    "smooth endoplasmic reticulum",
    "ribosomes",
    "nucleolus"
  ],
  answer: "smooth endoplasmic reticulum"
},
{
  question: "A major difference between prokaryotic and eukaryotic cells is that prokaryotic cells:",
  options: [
    "lack cytoplasm",
    "lack membrane-bound organelles",
    "lack DNA",
    "cannot reproduce"
  ],
  answer: "lack membrane-bound organelles"
},
{
  question: "Which structure is responsible for modifying and packaging proteins?",
  options: [
    "ribosome",
    "Golgi apparatus",
    "mitochondrion",
    "lysosome"
  ],
  answer: "Golgi apparatus"
},
{
  question: "If a plant cell loses water excessively, it becomes:",
  options: [
    "turgid",
    "flaccid",
    "plasmolysed",
    "rigid"
  ],
  answer: "plasmolysed"
},
{
  question: "Which of the following is NOT a function of the cell membrane?",
  options: [
    "selective permeability",
    "cell communication",
    "energy production",
    "protection"
  ],
  answer: "energy production"
},
{
  question: "Which organelle contains hydrolytic enzymes for intracellular digestion?",
  options: [
    "ribosome",
    "lysosome",
    "chloroplast",
    "nucleus"
  ],
  answer: "lysosome"
},
{
  question: "Which of the following best explains why red blood cells lack a nucleus?",
  options: [
    "to increase flexibility and oxygen-carrying capacity",
    "to reduce energy usage",
    "to prevent division",
    "to store more nutrients"
  ],
  answer: "to increase flexibility and oxygen-carrying capacity"
},
{
  question: "Which condition is necessary for osmosis to occur?",
  options: [
    "presence of ATP",
    "presence of a semi-permeable membrane",
    "high temperature",
    "enzyme activity"
  ],
  answer: "presence of a semi-permeable membrane"
},
{
  question: "Which of the following is correctly matched?",
  options: [
    "ribosome – lipid synthesis",
    "mitochondrion – protein synthesis",
    "chloroplast – photosynthesis",
    "Golgi body – respiration"
  ],
  answer: "chloroplast – photosynthesis"
},
{
  question: "Which of the following best describes diffusion?",
  options: [
    "movement against concentration gradient",
    "movement from high to low concentration",
    "movement requiring ATP",
    "movement through vesicles"
  ],
  answer: "movement from high to low concentration"
},
{
  question: "A cell with a large surface area to volume ratio is likely to:",
  options: [
    "have slower exchange of materials",
    "have faster exchange of materials",
    "require more energy",
    "store more waste"
  ],
  answer: "have faster exchange of materials"
},
{
  question: "Which organelle is responsible for lipid synthesis?",
  options: [
    "rough ER",
    "smooth ER",
    "ribosome",
    "nucleus"
  ],
  answer: "smooth ER"
},
{
  question: "Which of the following best explains why viruses are considered non-living?",
  options: [
    "they lack DNA",
    "they cannot reproduce independently",
    "they lack proteins",
    "they cannot mutate"
  ],
  answer: "they cannot reproduce independently"
},
{
  question: "Which cell structure is involved in spindle formation during cell division?",
  options: [
    "lysosome",
    "centrioles",
    "ribosome",
    "chloroplast"
  ],
  answer: "centrioles"
},
{
  question: "Which of the following is NOT membrane-bound?",
  options: [
    "nucleus",
    "mitochondrion",
    "ribosome",
    "lysosome"
  ],
  answer: "ribosome"
},
{
  question: "Which factor most directly affects the rate of diffusion?",
  options: [
    "cell type",
    "concentration gradient",
    "DNA content",
    "organelle number"
  ],
  answer: "concentration gradient"
},
{
  question: "Which of the following best explains selective permeability?",
  options: [
    "all substances pass freely",
    "only certain substances pass through",
    "no substances pass through",
    "only water passes through"
  ],
  answer: "only certain substances pass through"
},

{
  question: "Why are capillaries well suited for exchange of substances?",
  options: [
    "they have thick muscular walls",
    "they have a large diameter",
    "they have thin walls and large surface area",
    "they carry blood at high pressure"
  ],
  answer: "they have thin walls and large surface area"
},
{
  question: "Which of the following best explains why arteries have thick elastic walls?",
  options: [
    "to reduce blood pressure",
    "to withstand high pressure from the heart",
    "to increase diffusion rate",
    "to store nutrients"
  ],
  answer: "to withstand high pressure from the heart"
},
{
  question: "What is the main advantage of double circulation in mammals?",
  options: [
    "blood flows slower",
    "oxygenated and deoxygenated blood mix",
    "efficient oxygen delivery to tissues",
    "reduced heart activity"
  ],
  answer: "efficient oxygen delivery to tissues"
},
{
  question: "Which blood component is directly involved in immunity?",
  options: [
    "red blood cells",
    "platelets",
    "white blood cells",
    "plasma proteins"
  ],
  answer: "white blood cells"
},
{
  question: "A decrease in red blood cells will most likely result in:",
  options: [
    "increased immunity",
    "reduced oxygen transport",
    "faster blood clotting",
    "increased respiration rate"
  ],
  answer: "reduced oxygen transport"
},
{
  question: "Which structure ensures one-way flow of blood in the heart?",
  options: [
    "arteries",
    "valves",
    "capillaries",
    "atria"
  ],
  answer: "valves"
},
{
  question: "Which vessel carries oxygenated blood from the lungs to the heart?",
  options: [
    "pulmonary artery",
    "pulmonary vein",
    "aorta",
    "vena cava"
  ],
  answer: "pulmonary vein"
},
{
  question: "Why do veins have valves?",
  options: [
    "to increase pressure",
    "to prevent backflow of blood",
    "to speed up circulation",
    "to carry oxygen"
  ],
  answer: "to prevent backflow of blood"
},
{
  question: "Which factor increases the rate of transpiration in plants?",
  options: [
    "high humidity",
    "low temperature",
    "strong wind",
    "closed stomata"
  ],
  answer: "strong wind"
},
{
  question: "What is the main driving force of transpiration pull?",
  options: [
    "root pressure",
    "capillarity",
    "evaporation of water from leaves",
    "photosynthesis"
  ],
  answer: "evaporation of water from leaves"
},
{
  question: "Which tissue transports manufactured food in plants?",
  options: [
    "xylem",
    "phloem",
    "cambium",
    "epidermis"
  ],
  answer: "phloem"
},
{
  question: "Which of the following best explains why xylem vessels are lignified?",
  options: [
    "to store food",
    "to provide strength and prevent collapse",
    "to allow diffusion",
    "to transport sugars"
  ],
  answer: "to provide strength and prevent collapse"
},
{
  question: "Which of the following occurs during aerobic respiration?",
  options: [
    "glucose is converted to lactic acid",
    "oxygen is not required",
    "energy is released efficiently",
    "no ATP is produced"
  ],
  answer: "energy is released efficiently"
},
{
  question: "Which stage of respiration produces the most ATP?",
  options: [
    "glycolysis",
    "Krebs cycle",
    "electron transport chain",
    "fermentation"
  ],
  answer: "electron transport chain"
},
{
  question: "Why is anaerobic respiration less efficient than aerobic respiration?",
  options: [
    "it produces more ATP",
    "it does not use glucose",
    "it releases less energy per glucose molecule",
    "it requires oxygen"
  ],
  answer: "it releases less energy per glucose molecule"
},
{
  question: "Which of the following accumulates in muscles during vigorous exercise?",
  options: [
    "oxygen",
    "carbon dioxide",
    "lactic acid",
    "glucose"
  ],
  answer: "lactic acid"
},
{
  question: "Which organ is primarily responsible for gas exchange in humans?",
  options: [
    "trachea",
    "bronchus",
    "alveoli",
    "larynx"
  ],
  answer: "alveoli"
},
{
  question: "Which feature of alveoli increases efficiency of gas exchange?",
  options: [
    "thick walls",
    "small surface area",
    "rich blood supply",
    "low oxygen concentration"
  ],
  answer: "rich blood supply"
},
{
  question: "What happens to oxygen after it enters the blood?",
  options: [
    "it dissolves in plasma only",
    "it binds to haemoglobin",
    "it is stored in white blood cells",
    "it is excreted"
  ],
  answer: "it binds to haemoglobin"
},
{
  question: "Which of the following best explains ventilation?",
  options: [
    "movement of blood",
    "movement of air in and out of lungs",
    "exchange of gases in cells",
    "transport of oxygen"
  ],
  answer: "movement of air in and out of lungs"
},

{
  question: "Which of the following is the main excretory organ in humans?",
  options: [
    "liver",
    "kidney",
    "lungs",
    "skin"
  ],
  answer: "kidney"
},
{
  question: "Which process occurs in the nephron to remove waste from blood?",
  options: [
    "diffusion",
    "ultrafiltration",
    "osmosis",
    "active transport only"
  ],
  answer: "ultrafiltration"
},
{
  question: "Which substance is selectively reabsorbed in the kidney?",
  options: [
    "urea",
    "glucose",
    "carbon dioxide",
    "uric acid"
  ],
  answer: "glucose"
},
{
  question: "Which structure in the kidney is responsible for filtration?",
  options: [
    "loop of Henle",
    "glomerulus",
    "collecting duct",
    "ureter"
  ],
  answer: "glomerulus"
},
{
  question: "A failure of the kidney to reabsorb water properly will lead to:",
  options: [
    "dehydration",
    "increased blood pressure",
    "reduced urine production",
    "protein synthesis"
  ],
  answer: "dehydration"
},
{
  question: "Which hormone regulates water balance in the body?",
  options: [
    "insulin",
    "ADH",
    "thyroxine",
    "adrenaline"
  ],
  answer: "ADH"
},
{
  question: "Which of the following best explains homeostasis?",
  options: [
    "maintenance of constant internal environment",
    "control of movement",
    "production of energy",
    "digestion of food"
  ],
  answer: "maintenance of constant internal environment"
},
{
  question: "Which organ is involved in both excretion and temperature regulation?",
  options: [
    "kidney",
    "skin",
    "lungs",
    "heart"
  ],
  answer: "skin"
},
{
  question: "Which of the following is a nitrogenous waste in humans?",
  options: [
    "glucose",
    "urea",
    "oxygen",
    "carbon monoxide"
  ],
  answer: "urea"
},
{
  question: "Which process removes excess salts and water from the body?",
  options: [
    "digestion",
    "respiration",
    "sweating",
    "circulation"
  ],
  answer: "sweating"
},
{
  question: "Which part of the nephron is mainly involved in water reabsorption?",
  options: [
    "glomerulus",
    "loop of Henle",
    "Bowman’s capsule",
    "renal artery"
  ],
  answer: "loop of Henle"
},
{
  question: "Which of the following is NOT an excretory product?",
  options: [
    "urea",
    "carbon dioxide",
    "faeces",
    "water"
  ],
  answer: "faeces"
},
{
  question: "Dialysis is used when:",
  options: [
    "lungs fail",
    "kidneys fail",
    "heart fails",
    "brain fails"
  ],
  answer: "kidneys fail"
},
{
  question: "Which organ removes carbon dioxide from the body?",
  options: [
    "kidney",
    "skin",
    "lungs",
    "liver"
  ],
  answer: "lungs"
},
{
  question: "Which of the following best explains selective reabsorption?",
  options: [
    "all substances are absorbed",
    "only useful substances are reabsorbed",
    "only waste is absorbed",
    "nothing is absorbed"
  ],
  answer: "only useful substances are reabsorbed"
},
{
  question: "Which structure carries urine from kidney to bladder?",
  options: [
    "urethra",
    "ureter",
    "vein",
    "artery"
  ],
  answer: "ureter"
},
{
  question: "Which factor affects enzyme activity in homeostasis?",
  options: [
    "temperature",
    "color",
    "size",
    "shape"
  ],
  answer: "temperature"
},
{
  question: "Which organ converts ammonia into urea?",
  options: [
    "kidney",
    "liver",
    "lungs",
    "pancreas"
  ],
  answer: "liver"
},
{
  question: "Which system is mainly responsible for homeostasis?",
  options: [
    "digestive",
    "nervous and endocrine",
    "circulatory",
    "respiratory"
  ],
  answer: "nervous and endocrine"
},
{
  question: "Which of the following is a response to high body temperature?",
  options: [
    "vasoconstriction",
    "shivering",
    "vasodilation",
    "reduced sweating"
  ],
  answer: "vasodilation"
},

{
  question: "Which of the following correctly describes DNA?",
  options: [
    "single-stranded molecule",
    "double helix structure",
    "made of amino acids",
    "found only in cytoplasm"
  ],
  answer: "double helix structure"
},
{
  question: "Which component of DNA carries genetic information?",
  options: [
    "phosphate group",
    "deoxyribose sugar",
    "nitrogenous bases",
    "ribosomes"
  ],
  answer: "nitrogenous bases"
},
{
  question: "Which base pairs correctly in DNA?",
  options: [
    "A – G",
    "A – T",
    "C – A",
    "T – G"
  ],
  answer: "A – T"
},
{
  question: "Which process produces identical copies of DNA?",
  options: [
    "transcription",
    "translation",
    "replication",
    "mutation"
  ],
  answer: "replication"
},
{
  question: "Which of the following occurs during transcription?",
  options: [
    "DNA → protein",
    "DNA → RNA",
    "RNA → DNA",
    "protein → DNA"
  ],
  answer: "DNA → RNA"
},
{
  question: "Which molecule carries genetic code from nucleus to ribosome?",
  options: [
    "tRNA",
    "rRNA",
    "mRNA",
    "DNA"
  ],
  answer: "mRNA"
},
{
  question: "Which organelle is responsible for protein synthesis?",
  options: [
    "mitochondrion",
    "ribosome",
    "nucleus",
    "lysosome"
  ],
  answer: "ribosome"
},
{
  question: "Which of the following best explains a gene?",
  options: [
    "a unit of protein",
    "a segment of DNA coding for a trait",
    "a type of chromosome",
    "a type of cell"
  ],
  answer: "a segment of DNA coding for a trait"
},
{
  question: "A change in the DNA sequence is known as:",
  options: [
    "replication",
    "mutation",
    "transcription",
    "translation"
  ],
  answer: "mutation"
},
{
  question: "Which of the following best explains a chromosome?",
  options: [
    "a protein molecule",
    "a structure containing DNA and genes",
    "a type of enzyme",
    "a cell organelle only"
  ],
  answer: "a structure containing DNA and genes"
},
{
  question: "Which of the following is NOT a component of a nucleotide?",
  options: [
    "phosphate",
    "sugar",
    "nitrogen base",
    "amino acid"
  ],
  answer: "amino acid"
},
{
  question: "Which stage of cell cycle involves DNA replication?",
  options: [
    "G1 phase",
    "S phase",
    "G2 phase",
    "mitosis"
  ],
  answer: "S phase"
},
{
  question: "Which of the following best explains dominant allele?",
  options: [
    "always masked",
    "expressed in heterozygous condition",
    "found only in males",
    "always harmful"
  ],
  answer: "expressed in heterozygous condition"
},
{
  question: "A heterozygous genotype is:",
  options: [
    "AA",
    "aa",
    "Aa",
    "BB"
  ],
  answer: "Aa"
},
{
  question: "Which of the following best explains phenotype?",
  options: [
    "genetic makeup",
    "observable characteristics",
    "DNA sequence",
    "protein structure"
  ],
  answer: "observable characteristics"
},
{
  question: "In a monohybrid cross, the ratio 3:1 represents:",
  options: [
    "genotypic ratio",
    "phenotypic ratio",
    "mutation rate",
    "chromosome number"
  ],
  answer: "phenotypic ratio"
},
{
  question: "Which of the following best explains genotype?",
  options: [
    "appearance",
    "genetic composition",
    "environmental effect",
    "cell structure"
  ],
  answer: "genetic composition"
},
{
  question: "Which of the following causes variation in organisms?",
  options: [
    "identical genes",
    "mutation and recombination",
    "constant environment",
    "no reproduction"
  ],
  answer: "mutation and recombination"
},
{
  question: "Which type of variation shows distinct categories?",
  options: [
    "continuous variation",
    "discontinuous variation",
    "environmental variation",
    "random variation"
  ],
  answer: "discontinuous variation"
},
{
  question: "Which of the following best explains evolution?",
  options: [
    "sudden change in one organism",
    "gradual change in species over time",
    "daily adaptation",
    "cell division"
  ],
  answer: "gradual change in species over time"
},

{
  question: "Which factor directly affects the rate of photosynthesis by influencing enzyme activity?",
  options: [
    "light intensity",
    "temperature",
    "carbon dioxide concentration",
    "water availability"
  ],
  answer: "temperature"
},
{
  question: "Which of the following is the primary function of chlorophyll?",
  options: [
    "absorb light energy",
    "transport glucose",
    "store water",
    "release oxygen"
  ],
  answer: "absorb light energy"
},
{
  question: "Which gas is required for photosynthesis?",
  options: [
    "oxygen",
    "carbon dioxide",
    "nitrogen",
    "hydrogen"
  ],
  answer: "carbon dioxide"
},
{
  question: "Which of the following is a product of photosynthesis?",
  options: [
    "carbon dioxide",
    "water",
    "glucose",
    "nitrogen"
  ],
  answer: "glucose"
},
{
  question: "Where does the light-dependent reaction occur?",
  options: [
    "stroma",
    "thylakoid membrane",
    "cytoplasm",
    "nucleus"
  ],
  answer: "thylakoid membrane"
},
{
  question: "Which of the following best explains the role of water in photosynthesis?",
  options: [
    "provides carbon",
    "splits to release oxygen and electrons",
    "absorbs sunlight",
    "stores glucose"
  ],
  answer: "splits to release oxygen and electrons"
},
{
  question: "Which factor becomes limiting when all others are in excess?",
  options: [
    "limiting factor",
    "independent factor",
    "external factor",
    "random factor"
  ],
  answer: "limiting factor"
},
{
  question: "Which of the following is NOT required for photosynthesis?",
  options: [
    "light",
    "chlorophyll",
    "oxygen",
    "carbon dioxide"
  ],
  answer: "oxygen"
},
{
  question: "Which structure allows gas exchange in leaves?",
  options: [
    "xylem",
    "phloem",
    "stomata",
    "cuticle"
  ],
  answer: "stomata"
},
{
  question: "Which of the following increases the rate of photosynthesis?",
  options: [
    "low light intensity",
    "high carbon dioxide concentration",
    "low temperature",
    "closed stomata"
  ],
  answer: "high carbon dioxide concentration"
},
{
  question: "Which mineral is essential for chlorophyll formation?",
  options: [
    "nitrogen",
    "magnesium",
    "potassium",
    "phosphorus"
  ],
  answer: "magnesium"
},
{
  question: "A plant kept in darkness for long will:",
  options: [
    "increase photosynthesis",
    "store more glucose",
    "use stored food",
    "produce oxygen"
  ],
  answer: "use stored food"
},
{
  question: "Which of the following best explains translocation?",
  options: [
    "movement of water in plants",
    "movement of manufactured food",
    "movement of gases",
    "movement of minerals"
  ],
  answer: "movement of manufactured food"
},
{
  question: "Which tissue is responsible for transporting water in plants?",
  options: [
    "phloem",
    "xylem",
    "cambium",
    "epidermis"
  ],
  answer: "xylem"
},
{
  question: "Which condition would reduce the rate of photosynthesis?",
  options: [
    "increased light",
    "low carbon dioxide",
    "adequate water",
    "optimal temperature"
  ],
  answer: "low carbon dioxide"
},
{
  question: "Which process converts light energy into chemical energy?",
  options: [
    "respiration",
    "photosynthesis",
    "transpiration",
    "diffusion"
  ],
  answer: "photosynthesis"
},
{
  question: "Which of the following best explains the role of stomata?",
  options: [
    "transport water",
    "control gas exchange",
    "store food",
    "absorb nutrients"
  ],
  answer: "control gas exchange"
},
{
  question: "Which pigment absorbs light energy for photosynthesis?",
  options: [
    "haemoglobin",
    "chlorophyll",
    "melanin",
    "keratin"
  ],
  answer: "chlorophyll"
},
{
  question: "Which of the following is a deficiency symptom of nitrogen?",
  options: [
    "yellowing of leaves",
    "increased growth",
    "thicker stems",
    "larger leaves"
  ],
  answer: "yellowing of leaves"
},
{
  question: "Which of the following best explains why leaves are broad?",
  options: [
    "to store water",
    "to increase surface area for light absorption",
    "to reduce transpiration",
    "to protect the plant"
  ],
  answer: "to increase surface area for light absorption"
},

{
  question: "Which of the following best explains fertilization?",
  options: [
    "fusion of gametes",
    "cell division",
    "formation of zygote only",
    "development of embryo"
  ],
  answer: "fusion of gametes"
},
{
  question: "Where does fertilization occur in humans?",
  options: [
    "uterus",
    "ovary",
    "fallopian tube",
    "cervix"
  ],
  answer: "fallopian tube"
},
{
  question: "Which hormone is responsible for ovulation?",
  options: [
    "estrogen",
    "progesterone",
    "FSH",
    "LH"
  ],
  answer: "LH"
},
{
  question: "Which of the following best explains pollination?",
  options: [
    "fusion of gametes",
    "transfer of pollen to stigma",
    "seed formation",
    "fruit development"
  ],
  answer: "transfer of pollen to stigma"
},
{
  question: "Self-pollination occurs when:",
  options: [
    "pollen is transferred between different plants",
    "pollen is transferred within the same plant",
    "pollination involves insects",
    "pollination involves wind"
  ],
  answer: "pollen is transferred within the same plant"
},
{
  question: "Which structure develops into a fruit after fertilization?",
  options: [
    "ovule",
    "ovary",
    "stigma",
    "anther"
  ],
  answer: "ovary"
},
{
  question: "Which structure develops into a seed?",
  options: [
    "ovary",
    "ovule",
    "stigma",
    "style"
  ],
  answer: "ovule"
},
{
  question: "Which of the following best explains asexual reproduction?",
  options: [
    "involves two parents",
    "involves gamete fusion",
    "produces genetically identical offspring",
    "requires fertilization"
  ],
  answer: "produces genetically identical offspring"
},
{
  question: "Which method of asexual reproduction occurs in yeast?",
  options: [
    "binary fission",
    "budding",
    "fragmentation",
    "spore formation"
  ],
  answer: "budding"
},
{
  question: "Which structure produces sperm cells?",
  options: [
    "ovary",
    "testis",
    "uterus",
    "prostate"
  ],
  answer: "testis"
},
{
  question: "Which hormone maintains pregnancy?",
  options: [
    "estrogen",
    "progesterone",
    "FSH",
    "LH"
  ],
  answer: "progesterone"
},
{
  question: "Which of the following best explains implantation?",
  options: [
    "fertilization of egg",
    "attachment of embryo to uterus",
    "development of fetus",
    "release of egg"
  ],
  answer: "attachment of embryo to uterus"
},
{
  question: "Which of the following is an advantage of sexual reproduction?",
  options: [
    "no variation",
    "faster reproduction",
    "genetic variation",
    "no need for gametes"
  ],
  answer: "genetic variation"
},
{
  question: "Which of the following is a disadvantage of asexual reproduction?",
  options: [
    "requires two parents",
    "produces variation",
    "lack of genetic variation",
    "slow process"
  ],
  answer: "lack of genetic variation"
},
{
  question: "Which part of the flower produces pollen?",
  options: [
    "stigma",
    "style",
    "anther",
    "ovary"
  ],
  answer: "anther"
},
{
  question: "Which of the following is responsible for carrying sperm to the ovum?",
  options: [
    "ureter",
    "vas deferens",
    "fallopian tube",
    "urethra"
  ],
  answer: "fallopian tube"
},
{
  question: "Which of the following best explains metamorphosis?",
  options: [
    "growth without change",
    "sudden reproduction",
    "development involving distinct stages",
    "cell division only"
  ],
  answer: "development involving distinct stages"
},
{
  question: "Which stage follows fertilization?",
  options: [
    "gamete formation",
    "zygote formation",
    "ovulation",
    "pollination"
  ],
  answer: "zygote formation"
},
{
  question: "Which of the following best explains hermaphroditism?",
  options: [
    "organism has only male organs",
    "organism has both male and female organs",
    "organism reproduces asexually",
    "organism does not reproduce"
  ],
  answer: "organism has both male and female organs"
},
{
  question: "Which factor is necessary for seed germination?",
  options: [
    "light only",
    "oxygen, water, and suitable temperature",
    "soil only",
    "chlorophyll"
  ],
  answer: "oxygen, water, and suitable temperature"
},

{
  question: "Which of the following best defines an ecosystem?",
  options: [
    "a group of animals only",
    "interaction between organisms and their environment",
    "plants only",
    "non-living components only"
  ],
  answer: "interaction between organisms and their environment"
},
{
  question: "Which of the following is a biotic factor?",
  options: [
    "temperature",
    "light",
    "bacteria",
    "water"
  ],
  answer: "bacteria"
},
{
  question: "Which of the following is an abiotic factor?",
  options: [
    "fungi",
    "plants",
    "temperature",
    "animals"
  ],
  answer: "temperature"
},
{
  question: "Which organism is a primary producer?",
  options: [
    "grass",
    "lion",
    "snake",
    "human"
  ],
  answer: "grass"
},
{
  question: "Which of the following best explains a food chain?",
  options: [
    "flow of energy through organisms",
    "movement of water",
    "interaction of species only",
    "feeding habits only"
  ],
  answer: "flow of energy through organisms"
},
{
  question: "Which trophic level contains herbivores?",
  options: [
    "producers",
    "primary consumers",
    "secondary consumers",
    "tertiary consumers"
  ],
  answer: "primary consumers"
},
{
  question: "Which of the following best explains a food web?",
  options: [
    "single feeding relationship",
    "complex interconnected food chains",
    "simple food chain",
    "random feeding"
  ],
  answer: "complex interconnected food chains"
},
{
  question: "Which of the following organisms is a decomposer?",
  options: [
    "grass",
    "fungus",
    "goat",
    "eagle"
  ],
  answer: "fungus"
},
{
  question: "What is the main role of decomposers?",
  options: [
    "produce food",
    "break down dead organisms",
    "consume plants",
    "store energy"
  ],
  answer: "break down dead organisms"
},
{
  question: "Energy decreases along a food chain because:",
  options: [
    "it is destroyed",
    "it is lost as heat",
    "it increases upward",
    "it is stored completely"
  ],
  answer: "it is lost as heat"
},
{
  question: "Which of the following best explains population?",
  options: [
    "all species in an area",
    "same species in an area",
    "different organisms",
    "plants only"
  ],
  answer: "same species in an area"
},
{
  question: "Which factor limits population growth?",
  options: [
    "abundant food",
    "predation",
    "favorable climate",
    "low competition"
  ],
  answer: "predation"
},
{
  question: "Which of the following best explains habitat?",
  options: [
    "where organisms live",
    "how organisms feed",
    "interaction only",
    "feeding habits"
  ],
  answer: "where organisms live"
},
{
  question: "Which of the following best explains niche?",
  options: [
    "location only",
    "role of organism in ecosystem",
    "population size",
    "feeding only"
  ],
  answer: "role of organism in ecosystem"
},
{
  question: "Which of the following is an example of mutualism?",
  options: [
    "lion and zebra",
    "tick and dog",
    "bee and flower",
    "fungus and plant disease"
  ],
  answer: "bee and flower"
},
{
  question: "Which of the following is an example of parasitism?",
  options: [
    "algae and fungus",
    "tapeworm in human",
    "bee and flower",
    "bird and tree"
  ],
  answer: "tapeworm in human"
},
{
  question: "Which of the following best explains competition?",
  options: [
    "cooperation",
    "organisms fighting for resources",
    "feeding only",
    "movement"
  ],
  answer: "organisms fighting for resources"
},
{
  question: "Which cycle involves nitrogen fixation?",
  options: [
    "carbon cycle",
    "water cycle",
    "nitrogen cycle",
    "oxygen cycle"
  ],
  answer: "nitrogen cycle"
},
{
  question: "Which human activity leads to environmental pollution?",
  options: [
    "tree planting",
    "recycling",
    "burning fossil fuels",
    "conservation"
  ],
  answer: "burning fossil fuels"
},
{
  question: "Which of the following best explains conservation?",
  options: [
    "destruction of resources",
    "protection of environment",
    "overuse of resources",
    "pollution"
  ],
  answer: "protection of environment"
},

{
  question: "Which system is primarily responsible for coordination in the body?",
  options: [
    "digestive system",
    "nervous system",
    "circulatory system",
    "respiratory system"
  ],
  answer: "nervous system"
},
{
  question: "Which part of the brain controls voluntary actions?",
  options: [
    "cerebellum",
    "medulla oblongata",
    "cerebrum",
    "hypothalamus"
  ],
  answer: "cerebrum"
},
{
  question: "Which of the following is a reflex action?",
  options: [
    "walking",
    "thinking",
    "withdrawal from pain",
    "writing"
  ],
  answer: "withdrawal from pain"
},
{
  question: "Which organ is responsible for insulin production?",
  options: [
    "liver",
    "kidney",
    "pancreas",
    "stomach"
  ],
  answer: "pancreas"
},
{
  question: "A deficiency of insulin leads to:",
  options: [
    "hypertension",
    "diabetes mellitus",
    "asthma",
    "anemia"
  ],
  answer: "diabetes mellitus"
},
{
  question: "Which of the following best explains digestion?",
  options: [
    "absorption of nutrients",
    "breakdown of food into simpler substances",
    "movement of food",
    "storage of food"
  ],
  answer: "breakdown of food into simpler substances"
},
{
  question: "Which enzyme breaks down proteins in the stomach?",
  options: [
    "amylase",
    "lipase",
    "pepsin",
    "maltase"
  ],
  answer: "pepsin"
},
{
  question: "Where does most absorption of digested food occur?",
  options: [
    "stomach",
    "small intestine",
    "large intestine",
    "oesophagus"
  ],
  answer: "small intestine"
},
{
  question: "Which of the following best explains assimilation?",
  options: [
    "digestion of food",
    "absorption into blood",
    "use of nutrients by cells",
    "excretion of waste"
  ],
  answer: "use of nutrients by cells"
},
{
  question: "Which part of the respiratory system is shared with the digestive system?",
  options: [
    "trachea",
    "pharynx",
    "bronchus",
    "alveoli"
  ],
  answer: "pharynx"
},
{
  question: "Which of the following best explains vaccination?",
  options: [
    "treatment of disease",
    "introduction of weakened pathogens to stimulate immunity",
    "removal of pathogens",
    "destruction of cells"
  ],
  answer: "introduction of weakened pathogens to stimulate immunity"
},
{
  question: "Which of the following best explains immunity?",
  options: [
    "body’s defense against disease",
    "digestion process",
    "movement of blood",
    "growth of cells"
  ],
  answer: "body’s defense against disease"
},
{
  question: "Which of the following is a communicable disease?",
  options: [
    "diabetes",
    "hypertension",
    "malaria",
    "cancer"
  ],
  answer: "malaria"
},
{
  question: "Which vector transmits malaria?",
  options: [
    "housefly",
    "tsetse fly",
    "female Anopheles mosquito",
    "cockroach"
  ],
  answer: "female Anopheles mosquito"
},
{
  question: "Which of the following is a non-communicable disease?",
  options: [
    "cholera",
    "tuberculosis",
    "cancer",
    "influenza"
  ],
  answer: "cancer"
},
{
  question: "Which of the following best explains biotechnology?",
  options: [
    "use of machines only",
    "use of living organisms in industry",
    "study of plants",
    "study of animals"
  ],
  answer: "use of living organisms in industry"
},
{
  question: "Which of the following is an example of biotechnology?",
  options: [
    "fermentation",
    "digestion",
    "respiration",
    "transpiration"
  ],
  answer: "fermentation"
},
{
  question: "Which of the following best explains balanced diet?",
  options: [
    "only carbohydrates",
    "only proteins",
    "all nutrients in correct proportion",
    "only fats"
  ],
  answer: "all nutrients in correct proportion"
},
{
  question: "Which of the following is a function of the liver?",
  options: [
    "production of insulin",
    "detoxification of harmful substances",
    "transport of oxygen",
    "production of hormones only"
  ],
  answer: "detoxification of harmful substances"
},
{
  question: "Which of the following best explains homeostasis in humans?",
  options: [
    "movement of food",
    "maintenance of internal balance",
    "growth of tissues",
    "digestion process"
  ],
  answer: "maintenance of internal balance"
},

{
  question: "In a dihybrid cross AaBb × AaBb, what is the phenotypic ratio?",
  options: [
    "3:1",
    "9:3:3:1",
    "1:1:1:1",
    "2:1"
  ],
  answer: "9:3:3:1"
},
{
  question: "Which of the following best explains sex-linked inheritance?",
  options: [
    "traits found only in females",
    "traits carried on sex chromosomes",
    "traits found in all chromosomes",
    "traits caused by environment"
  ],
  answer: "traits carried on sex chromosomes"
},
{
  question: "Which disorder is sex-linked?",
  options: [
    "diabetes",
    "haemophilia",
    "cancer",
    "hypertension"
  ],
  answer: "haemophilia"
},
{
  question: "A carrier of a recessive trait is:",
  options: [
    "AA",
    "aa",
    "Aa",
    "BB"
  ],
  answer: "Aa"
},
{
  question: "Which process ensures genetic variation during meiosis?",
  options: [
    "mitosis",
    "crossing over",
    "transpiration",
    "respiration"
  ],
  answer: "crossing over"
},
{
  question: "Which of the following best explains mutation?",
  options: [
    "normal cell division",
    "permanent change in DNA sequence",
    "temporary change",
    "cell growth"
  ],
  answer: "permanent change in DNA sequence"
},
{
  question: "Which of the following is NOT a type of mutation?",
  options: [
    "gene mutation",
    "chromosomal mutation",
    "cell mutation",
    "point mutation"
  ],
  answer: "cell mutation"
},
{
  question: "Which factor can cause mutation?",
  options: [
    "enzymes",
    "radiation",
    "water",
    "oxygen"
  ],
  answer: "radiation"
},
{
  question: "Which of the following best explains enzyme specificity?",
  options: [
    "enzymes react with any substrate",
    "enzymes are destroyed easily",
    "enzymes act on specific substrates",
    "enzymes do not change"
  ],
  answer: "enzymes act on specific substrates"
},
{
  question: "Which model explains enzyme action?",
  options: [
    "diffusion model",
    "lock and key model",
    "cell model",
    "transport model"
  ],
  answer: "lock and key model"
},
{
  question: "Which factor affects enzyme activity most directly?",
  options: [
    "color",
    "temperature",
    "shape",
    "size"
  ],
  answer: "temperature"
},
{
  question: "At very high temperature, enzymes:",
  options: [
    "work faster",
    "denature",
    "become inactive temporarily",
    "increase in number"
  ],
  answer: "denature"
},
{
  question: "Which of the following best explains pH effect on enzymes?",
  options: [
    "no effect",
    "changes enzyme shape",
    "increases size",
    "adds energy"
  ],
  answer: "changes enzyme shape"
},
{
  question: "Which of the following is an example of enzyme action in humans?",
  options: [
    "photosynthesis",
    "digestion",
    "respiration only",
    "transpiration"
  ],
  answer: "digestion"
},
{
  question: "Which of the following best explains ecological pyramid?",
  options: [
    "food chain",
    "graphical representation of trophic levels",
    "population growth",
    "energy cycle"
  ],
  answer: "graphical representation of trophic levels"
},
{
  question: "Which pyramid is always upright?",
  options: [
    "numbers",
    "biomass",
    "energy",
    "population"
  ],
  answer: "energy"
},
{
  question: "Which of the following best explains ecological succession?",
  options: [
    "movement of animals",
    "gradual change in species composition",
    "feeding pattern",
    "climate change"
  ],
  answer: "gradual change in species composition"
},
{
  question: "Which type of succession occurs on bare land?",
  options: [
    "secondary succession",
    "primary succession",
    "tertiary succession",
    "random succession"
  ],
  answer: "primary succession"
},
{
  question: "Which of the following best explains carrying capacity?",
  options: [
    "maximum population an environment can support",
    "minimum population",
    "population decrease",
    "random growth"
  ],
  answer: "maximum population an environment can support"
},
{
  question: "Which of the following best explains logistic growth?",
  options: [
    "unlimited growth",
    "growth with limiting factors",
    "no growth",
    "random growth"
  ],
  answer: "growth with limiting factors"
},

{
  question: "The diagram shows a typical plant cell. Which structure is responsible for maintaining cell shape?",
  image: "/images/bio1.png",
  options: ["Cell wall", "Nucleus", "Cytoplasm", "Mitochondrion"],
  answer: "Cell wall"
},

{
  question: "The diagram shows an animal cell. Which organelle is the site of aerobic respiration?",
  image: "/images/bio2.png",
  options: ["Mitochondrion", "Ribosome", "Nucleus", "Golgi body"],
  answer: "Mitochondrion"
},

{
  question: "The diagram shows a red blood cell. What is its main function?",
  image: "/images/bio3.png",
  options: ["Transport oxygen", "Fight infection", "Produce hormones", "Store nutrients"],
  answer: "Transport oxygen"
},

{
  question: "The diagram shows diffusion across a membrane. What is the driving force for diffusion?",
  image: "/images/bio4.png",
  options: ["Concentration gradient", "Energy", "Pressure", "Temperature"],
  answer: "Concentration gradient"
},

{
  question: "The diagram shows osmosis in a plant cell. What will happen in a hypotonic solution?",
  image: "/images/bio5.png",
  options: ["Cell becomes turgid", "Cell shrinks", "Cell bursts", "No change"],
  answer: "Cell becomes turgid"
},

{
  question: "The diagram shows active transport. What is required for this process?",
  image: "/images/bio6.png",
  options: ["Energy (ATP)", "Water", "Oxygen", "Heat"],
  answer: "Energy (ATP)"
},

{
  question: "The diagram shows a neuron. What is its function?",
  image: "/images/bio7.png",
  options: ["Transmit impulses", "Transport oxygen", "Digestion", "Excretion"],
  answer: "Transmit impulses"
},

{
  question: "The diagram shows a root hair cell. Why is it adapted for absorption?",
  image: "/images/bio8.png",
  options: ["Large surface area", "Thick wall", "No nucleus", "Small size"],
  answer: "Large surface area"
},

{
  question: "The diagram shows a cell undergoing plasmolysis. What happens to the cytoplasm?",
  image: "/images/bio9.png",
  options: ["Shrinks away from wall", "Expands", "Remains same", "Disappears"],
  answer: "Shrinks away from wall"
},

{
  question: "The diagram shows levels of organization. Which sequence is correct?",
  image: "/images/bio10.png",
  options: ["Cell â†’ Tissue â†’ Organ â†’ System", "Tissue â†’ Cell â†’ Organ â†’ System", "Organ â†’ Cell â†’ Tissue â†’ System", "Cell â†’ Organ â†’ Tissue â†’ System"],
  answer: "Cell â†’ Tissue â†’ Organ â†’ System"
},

{
  question: "The diagram shows Amoeba. Which structure is used for movement?",
  image: "/images/bio11.png",
  options: ["Pseudopodia", "Cilia", "Flagellum", "Cell membrane"],
  answer: "Pseudopodia"
},

{
  question: "The diagram shows Paramecium. What structure is responsible for movement?",
  image: "/images/bio12.png",
  options: ["Cilia", "Flagella", "Pseudopodia", "Nucleus"],
  answer: "Cilia"
},

{
  question: "The diagram shows Euglena. Why is it considered both plant and animal?",
  image: "/images/bio13.png",
  options: ["Has chloroplast and moves", "Has no nucleus", "Is multicellular", "Has cell wall"],
  answer: "Has chloroplast and moves"
},

{
  question: "The diagram shows Spirogyra. What is the function of the spiral structure?",
  image: "/images/bio14.png",
  options: ["Photosynthesis", "Movement", "Reproduction", "Respiration"],
  answer: "Photosynthesis"
},

{
  question: "The diagram shows Rhizopus. What type of nutrition does it exhibit?",
  image: "/images/bio15.png",
  options: ["Saprophytic", "Autotrophic", "Parasitic", "Holozoic"],
  answer: "Saprophytic"
},

{
  question: "The diagram shows the life cycle of a cockroach. What type of metamorphosis occurs?",
  image: "/images/bio16.png",
  options: ["Incomplete metamorphosis", "Complete metamorphosis", "No metamorphosis", "Alternation"],
  answer: "Incomplete metamorphosis"
},

{
  question: "The diagram shows stages of butterfly development. What type of metamorphosis is this?",
  image: "/images/bio17.png",
  options: ["Complete metamorphosis", "Incomplete metamorphosis", "Binary fission", "Budding"],
  answer: "Complete metamorphosis"
},

{
  question: "The diagram shows a cockroach. Which part is used for respiration?",
  image: "/images/bio18.png",
  options: ["Spiracles", "Gills", "Lungs", "Skin"],
  answer: "Spiracles"
},

{
  question: "The diagram shows Tilapia. Which structure helps in movement?",
  image: "/images/bio19.png",
  options: ["Fins", "Gills", "Scales", "Eyes"],
  answer: "Fins"
},

{
  question: "The diagram shows a fish. What structure is used for gaseous exchange?",
  image: "/images/bio20.png",
  options: ["Gills", "Lungs", "Skin", "Spiracles"],
  answer: "Gills"
},

{
  question: "The diagram shows the human heart. Which chamber pumps blood to the body?",
  image: "/images/bio21.png",
  options: ["Left ventricle", "Right ventricle", "Left atrium", "Right atrium"],
  answer: "Left ventricle"
},

{
  question: "The diagram shows the heart. What is the function of valves?",
  image: "/images/bio22.png",
  options: ["Prevent backflow", "Increase pressure", "Pump blood", "Filter blood"],
  answer: "Prevent backflow"
},

{
  question: "The diagram shows blood vessels. Which vessel carries blood away from the heart?",
  image: "/images/bio23.png",
  options: ["Artery", "Vein", "Capillary", "Ventricle"],
  answer: "Artery"
},

{
  question: "The diagram shows red blood cells. What is their main function?",
  image: "/images/bio24.png",
  options: ["Transport oxygen", "Fight infection", "Clot blood", "Produce hormones"],
  answer: "Transport oxygen"
},

{
  question: "The diagram shows the lungs. Where does gaseous exchange occur?",
  image: "/images/bio25.png",
  options: ["Alveoli", "Bronchi", "Trachea", "Ribs"],
  answer: "Alveoli"
},

{
  question: "The diagram shows breathing mechanism. What happens during inhalation?",
  image: "/images/bio26.png",
  options: ["Diaphragm contracts", "Diaphragm relaxes", "Ribs move inward", "Pressure increases"],
  answer: "Diaphragm contracts"
},

{
  question: "The diagram shows the digestive system. Where does digestion begin?",
  image: "/images/bio27.png",
  options: ["Mouth", "Stomach", "Intestine", "Liver"],
  answer: "Mouth"
},

{
  question: "The diagram shows enzymes in digestion. Which enzyme breaks down starch?",
  image: "/images/bio28.png",
  options: ["Amylase", "Protease", "Lipase", "Pepsin"],
  answer: "Amylase"
},

{
  question: "The diagram shows small intestine. What is its main function?",
  image: "/images/bio29.png",
  options: ["Absorption of nutrients", "Digestion only", "Water storage", "Gas exchange"],
  answer: "Absorption of nutrients"
},

{
  question: "The diagram shows liver. What is one of its functions?",
  image: "/images/bio30.png",
  options: ["Detoxification", "Breathing", "Pumping blood", "Movement"],
  answer: "Detoxification"
},

{
  question: "The diagram shows a transverse section of a leaf. Which part contains chloroplasts?",
  image: "/images/bio31.png",
  options: ["Palisade mesophyll", "Xylem", "Epidermis", "Cuticle"],
  answer: "Palisade mesophyll"
},

{
  question: "The diagram shows a leaf. What is the main function of stomata?",
  image: "/images/bio32.png",
  options: ["Gas exchange", "Transport water", "Photosynthesis", "Support"],
  answer: "Gas exchange"
},

{
  question: "The diagram shows photosynthesis process. Which gas is taken in?",
  image: "/images/bio33.png",
  options: ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
  answer: "Carbon dioxide"
},

{
  question: "The diagram shows a plant exposed to sunlight. What is produced during photosynthesis?",
  image: "/images/bio34.png",
  options: ["Glucose", "Protein", "Fat", "Minerals"],
  answer: "Glucose"
},

{
  question: "The diagram shows transpiration. What drives water movement in plants?",
  image: "/images/bio35.png",
  options: ["Transpiration pull", "Gravity", "Pressure", "Diffusion"],
  answer: "Transpiration pull"
},

{
  question: "The diagram shows xylem tissue. What does it transport?",
  image: "/images/bio36.png",
  options: ["Water and minerals", "Food", "Oxygen", "Carbon dioxide"],
  answer: "Water and minerals"
},

{
  question: "The diagram shows phloem tissue. What does it transport?",
  image: "/images/bio37.png",
  options: ["Food", "Water", "Oxygen", "Minerals"],
  answer: "Food"
},

{
  question: "The diagram shows factors affecting photosynthesis. Which factor increases rate?",
  image: "/images/bio38.png",
  options: ["Light intensity", "Darkness", "Low temperature", "No COâ‚‚"],
  answer: "Light intensity"
},

{
  question: "The diagram shows a leaf losing water. What is this process called?",
  image: "/images/bio39.png",
  options: ["Transpiration", "Respiration", "Photosynthesis", "Diffusion"],
  answer: "Transpiration"
},

{
  question: "The diagram shows opening and closing of stomata. What controls this process?",
  image: "/images/bio40.png",
  options: ["Guard cells", "Epidermis", "Xylem", "Phloem"],
  answer: "Guard cells"
},

{
  question: "The diagram shows a food chain. Which organism is the producer?",
  image: "/images/bio41.png",
  options: ["Green plant", "Herbivore", "Carnivore", "Decomposer"],
  answer: "Green plant"
},

{
  question: "The diagram shows a food web. What is the role of decomposers?",
  image: "/images/bio42.png",
  options: ["Break down dead matter", "Produce food", "Consume plants", "Store energy"],
  answer: "Break down dead matter"
},

{
  question: "The diagram shows an ecological pyramid. Which level has the most energy?",
  image: "/images/bio43.png",
  options: ["Producers", "Primary consumers", "Secondary consumers", "Tertiary consumers"],
  answer: "Producers"
},

{
  question: "The diagram shows population growth curve. What type of curve is S-shaped?",
  image: "/images/bio44.png",
  options: ["Sigmoid", "Exponential", "Linear", "Circular"],
  answer: "Sigmoid"
},

{
  question: "The diagram shows factors affecting population. Which is density dependent?",
  image: "/images/bio45.png",
  options: ["Competition", "Flood", "Fire", "Drought"],
  answer: "Competition"
},

{
  question: "The diagram shows a genetic cross. What is the expected ratio for monohybrid cross?",
  image: "/images/bio46.png",
  options: ["3:1", "1:1", "9:3:3:1", "2:1"],
  answer: "3:1"
},

{
  question: "The diagram shows chromosomes. What carries genetic information?",
  image: "/images/bio47.png",
  options: ["DNA", "Protein", "Lipids", "Carbohydrates"],
  answer: "DNA"
},

{
  question: "The diagram shows variation in organisms. What type of variation is shown?",
  image: "/images/bio48.png",
  options: ["Continuous variation", "Discontinuous variation", "Mutation", "Evolution"],
  answer: "Continuous variation"
},

{
  question: "The diagram shows natural selection. What happens to advantageous traits?",
  image: "/images/bio49.png",
  options: ["Increase in population", "Disappear", "Remain same", "Become harmful"],
  answer: "Increase in population"
},

{
  question: "The diagram shows evolution. What is evolution?",
  image: "/images/bio50.png",
  options: ["Gradual change over time", "Sudden change", "No change", "Instant adaptation"],
  answer: "Gradual change over time"
}

];

export default biologyQuestions;



